/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox } from '@mantine/core'

function MissingTransactionFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Checkbox
        checked={value === 'true'}
        id="missing_transaction_filter"
        label={intl.formatMessage({
          id: 'missing_transaction',
          defaultMessage: 'Transaction manquante'
        })}
        name="missingTransaction"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
    </Filter>
  )
}

export default MissingTransactionFilter
